import React from 'react';
import 'date-fns';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Typography,
  AppBar,
  Tabs,
  Tab,
  Slide,
  useTheme, 
  useMediaQuery
} from '@material-ui/core';
import { useState, useEffect } from 'react';
import MenuVideo from 'src/app/components/camera/MenuVideo';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { getVehicleLicensePlateCamera } from 'src/features/vehicleSlice';
import PlaybackMenu from '../../playback/PlaybackMenu';

const TabPanel = props => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const CustomTab = withStyles({
  root: {
    backgroundColor: '#F6F6F6',
    color: '#475461',
    fontSize: '14px'
  },
  selected: {
    backgroundColor: '#ffffff',
    color: '#D9042F',
    fontWeight: 600,
    fontSize: '14px'
  }
})(Tab);

const MenuControl = ({ showMenu, fetchData, fetchDataByUserId, deviceSerial }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [carStatus, setCarStatus] = useState(null);
  const [listVehiclesCamera4G, setListVehiclesCamera4G] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {isAdmin, isAgency, agencyId} = useSelector(state => state.authSlice);
  const listVehicleTracking = useSelector(
    state => state.vehicleSlice.listVehicleTracking
  );
  const statisticVehicleStatus = useSelector(
    state => state.vehicleSlice.statisticVehicleStatus
  );

  useEffect(() => {
    if (carStatus) {
      const listVehicleStatus = listVehicleTracking.filter(
        vehicle => vehicle.device_status === carStatus && vehicle.debt === false
      );
      setListVehiclesCamera4G(listVehicleStatus);
    } else {
      setListVehiclesCamera4G(listVehicleTracking);
    }
  }, [carStatus, listVehicleTracking]);

  useEffect(() => {
    if (isAgency) {
      dispatch(getVehicleLicensePlateCamera(`/${agencyId}`));
    } else {
      dispatch(getVehicleLicensePlateCamera(''));
    }
  }, [isAdmin, isAgency]);

  return (
    <Slide
      direction="right"
      in={showMenu}
      style={{
        borderRadius: '8px',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        zIndex: 450,
        position: !deviceSerial ? 'absolute' : (showMenu ? 'relative' : 'absolute'),
        top: !deviceSerial ? '0px' : 'auto',
        left: !deviceSerial ? '0px' : 'auto',
        height: !deviceSerial ? 'calc(100vh - 66px)' : '100%'
      }}
    >
      <Card
        style={{
          width: isMobile ? '100%' : '384px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div className={classes.root} style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}>
          <AppBar
            position="static"
            style={{
              backgroundColor: '#ffffff',
              boxShadow: 'none',
            }}
          >
            <Tabs
              value={value}
              variant="fullWidth"
              onChange={handleChange}
              centered
              aria-label="simple tabs example"
              style={{
                width: '100%'
              }}
              TabIndicatorProps={{ hidden: true }}
            >
              <CustomTab
                label="Giám sát trực tiếp"
                {...a11yProps(0)}
                style={{
                  textTransform: 'none',
                  height: '100%'
                }}
                onClick={() => navigate('/app/video/streaming?show_menu=true')}
              />
              <CustomTab
                label="Phát lại video"
                {...a11yProps(1)}
                style={{
                  textTransform: 'none',
                  height: '100%'
                }}
                onClick={() => navigate('/app/video/playback')}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <MenuVideo
              vehiclesCamera4G={listVehiclesCamera4G}
              statisticVehicleStatus={statisticVehicleStatus}
              carStatus={carStatus}
              setCarStatus={setCarStatus}
              fetchData={fetchData}
              fetchDataByUserId={fetchDataByUserId}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <PlaybackMenu listVehicle={listVehiclesCamera4G} />
          </TabPanel>
        </div>
      </Card>
    </Slide>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}));

export default MenuControl;
